import "./chunk-N3ETBM74.js";
const getEnvironment = () => {
  if (typeof window === "undefined") return "dev";
  else if (window.location.hostname === "www.dfds.com") return "prod";
  else if (window.location.hostname.includes("-prod-dfds")) return "prod";
  else if (window.location.hostname.includes("app-travel-search-prod")) return "prod";
  else if (window.location.hostname.includes("prod.dfds")) return "prod";
  else if (window.location.hostname.includes("dfds-gatsby-bucket-preprod"))
    return "prod";
  else if (window.location.hostname.includes("dfds-unified-web.vercel.app"))
    return "prod";
  else if (window.location.hostname.includes("-dev.dfds")) return "dev";
  else if (window.location.hostname.includes("dev.dfds")) return "dev";
  else if (window.location.hostname.includes("dotcom-pr.dfds.com")) return "dev";
  else if (window.location.hostname.includes("localhost"))
    return process.env.NEXT_PUBLIC_ENVIRONMENT || "dev";
  else if (window.location.hostname.includes("unified-web-pr")) return "dev";
  else if (window.location.hostname.includes("test.dfds")) return "test";
  else if (window.location.hostname.includes("-nonprod.dfds")) return "test";
  else if (window.location.hostname.includes("-test.dfds")) return "test";
  else if (window.location.hostname.includes("-test-")) return "test";
  else if (window.location.hostname.includes("unified-web-staging"))
    return "test";
  else if (window.location.hostname.includes("accept.dfds")) return "accept";
  else if (window.location.hostname.includes("-uat.dfds")) return "accept";
  else if (window.location.hostname.includes("-uat-")) return "accept";
  else if (window.location.hostname.includes("uat.dfds")) return "accept";
  else throw new Error("Unknown subdomain");
};
const getClientId = (env2) => {
  if (typeof window === "undefined") return "dev";
  else if (env2 === "dev") return "91ef71ea-6e59-4283-8213-e9ded8fd25df";
  else if (env2 === "test") return "4cc97c5b-fd2b-42e8-9a5a-1c2620a9a07b";
  else if (env2 === "accept") return "93946ba0-cfca-40c2-847e-f9dfe2d471cf";
  else if (env2 === "prod") return "0022f598-b118-47b4-b4f0-c825d6890124";
  throw new Error("Unknown environment");
};
const env = getEnvironment();
const envWithOrWithoutDash = env === "prod" ? "" : env + "-";
const clientId = getClientId(env);
const msalAuthSettings = {
  config: {
    auth: {
      clientId,
      authority: env === "prod" ? `https://dfdsb2c.b2clogin.com/id.dfds.com/b2c_1a_signin_react/` : `https://dfdsb2c${env}.b2clogin.com/${envWithOrWithoutDash}id.dfds.com/b2c_1a_signin_react/`,
      knownAuthorities: env === "prod" ? ["https://dfdsb2c.b2clogin.com"] : [`https://dfdsb2c${env}.b2clogin.com`],
      redirectUri: typeof window === "undefined" ? "/" : `${window.location.origin}/redirect`
    },
    cache: {
      cacheLocation: "localStorage"
    }
  },
  scopes: [
    `openid https://${envWithOrWithoutDash}id.dfds.com/userprofilestore/CIAM.LoyaltycardApi.Readcurrentuser.Swg https://${envWithOrWithoutDash}id.dfds.com/userprofilestore/CIAM.LoyaltycardApi.Writecurrentuser.Swg https://${envWithOrWithoutDash}id.dfds.com/userprofilestore/CR.LoyaltycardApi.Readcurrentuser.Swg https://${envWithOrWithoutDash}id.dfds.com/userprofilestore/CR.LoyaltycardApi.Writecurrentuser.Swg`
  ]
};
export {
  msalAuthSettings
};
